import React, { memo } from 'react';
import { KeyboardlessInput } from '@adc/parallax-component-library';
import { IconChevronDown, IconValidationInvalid } from '@adc/parallax-icons';
const SelectorInput = memo(({ onClick, testID, value, label, children, errorMessage, error, isTouched, ...rest }) => {
    const hasError = isTouched && error;
    return (React.createElement(KeyboardlessInput, { testID: testID, inlineIconConfig: {
            testID: 'chevron-down',
            icon: React.createElement(IconChevronDown, null),
            color: '$interactive.tertiary.enabled.onColor',
        }, onPress: onClick, value: value, label: label, error: hasError, supportingIconConfig: hasError ? { icon: React.createElement(IconValidationInvalid, null) } : undefined, supportingText: hasError ? errorMessage : undefined, ...rest }, children));
});
SelectorInput.displayName = 'SelectorInput';
export { SelectorInput };
